export enum PermissionConsts {
    //PAGES
    Pages_Tenants = 'Pages.Tenants',
    Pages_Roles = 'Pages.Roles',
    Pages_Users = 'Pages.Users',
    Pages_Users_Activation = 'Pages.Users.Activation',
    Pages_Documents = 'Pages.Documents',
    Pages_Customers = 'Pages.Customers',
    Pages_Paperworks = 'Pages.Paperworks',
    Pages_MyPaperwork = 'Pages.MyPaperworks',
    Pages_MyProfile = 'Pages.MyProfile',
    Pages_Wizard = 'Pages.Wizard',

    //USER
    User_RequestEmailConfirmation = 'User.RequestEmailConfirmation',
    User_Detail = 'User.Detail',
    User_Get = 'User.Get',
    User_Create = 'User.Create',
    User_Edit = 'User.Edit',
    User_Delete = 'User.Delete',
    User_ForceResetPassword = 'User.ForceResetPassword',
    User_Deactivate = 'User.Deactivate',
    User_UnlockLogin = 'User.UnlockLogin',

    //CUSTOMERS
    Customer_List = 'Customer.List',
    Customer_Detail = 'Customer.Detail',
    Customer_Create = 'Customer.Create',
    Customer_Update = 'Customer.Update',
    Customer_Delete = 'Customer.Delete',
    Customer_SetAccount = 'Customer.SetAccount',

    //DUCUMENTS
    Document_List = 'Document.List',
    Document_Detail = 'Document.Detail',
    Document_Create = 'Document.Create',
    Document_Update = 'Document.Update',
    Document_Delete = 'Document.Delete',

    //PAPERWORKS
    Paperwork_List = 'Paperwork.List',
    Paperwork_Detail = 'Paperwork.Detail',
    Paperwork_Create = 'Paperwork.Create',
    Paperwork_Update = 'Paperwork.Update',
    Paperwork_Delete = 'Paperwork.Delete',

    Paperwork_Compile = 'Paperwork.Compile',
    Paperwork_StartAndReview = 'Paperwork.StartAndReview',

    //PAPERWORKTEMPLATES
    PaperworkTemplate_List = 'PaperworkTemplate.List',
    PaperworkTemplate_Detail = 'PaperworkTemplate.Detail',
    PaperworkTemplate_Create = 'PaperworkTemplate.Create',
    PaperworkTemplate_Update = 'PaperworkTemplate.Update',
    PaperworkTemplate_Delete = 'PaperworkTemplate.Delete',

    //DOCUMENTCOMPILATION
    DocumentCompilation_List = 'DocumentCompilation.List',
    DocumentCompilation_Detail = 'DocumentCompilation.Detail',
    DocumentCompilation_Update = 'DocumentCompilation.Update',
}
